// frontend/src/hooks/useEmailsSent.js
import { useEffect, useState } from 'react';
import apiClient from '../api/client';
import useAuthToken from './useAuthToken';

export default function useEmailsSent() {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = useAuthToken();


  useEffect(() => {
    console.log('📨 useEmailsSent — token:', token);
  
    if (!token) {
      console.warn('No token available — skipping email stats fetch');
      setLoading(false);
      return;
    }
  
    apiClient.get('/executions/email-sent?days=30')
      .then(res => {
        console.log('✅ Emails sent response:', res.data.count);
        setCount(res.data.count);
      })
      .catch(err => {
        if (err.response?.status === 401) {
          console.warn('401 from email stats — likely due to early render');
        } else {
          console.error('Failed to fetch emails sent:', err);
          setError(err);
        }
      })
      .finally(() => setLoading(false));
  }, [token]);
  
  return { emailsSent: count, isLoading: loading, error };
}
